"use client";

import React from "react";
import {
  MsalAuthenticationTemplate,
} from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import useAxiosMiddleware from "@/hooks/useAxiosMiddleware";
import useInitAxios from "@/hooks/useInitAxios";

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  useInitAxios();
  useAxiosMiddleware();

  return (
    <>
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
        {children}
      </MsalAuthenticationTemplate>
    </>
  );
}
